import React, { useState } from 'react';
import { X } from 'lucide-react';

const WhatsAppButton = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const phoneNumber = '447948213565';
  const defaultMessage = "Hi Dr. Michael, I'd like to enquire about tuition.";
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(defaultMessage)}`;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '24px',
        left: '24px',
        zIndex: 9998,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '8px'
      }}
    >
      {isExpanded && (
        <div
          style={{
            background: '#FFFCF5',
            borderRadius: '4px',
            padding: '20px',
            boxShadow: '0 12px 40px rgba(15, 23, 42, 0.25)',
            border: '1px solid #C5A059',
            maxWidth: '280px',
            marginBottom: '8px',
            animation: 'slideInLeft 0.3s ease',
            position: 'relative'
          }}
        >
          <button
            onClick={() => setIsExpanded(false)}
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: '4px',
              color: '#0F172A'
            }}
            data-testid="whatsapp-close"
          >
            <X size={14} />
          </button>

          <div style={{
            fontSize: '0.65rem', fontWeight: 600, letterSpacing: '0.2em',
            textTransform: 'uppercase', color: '#C5A059', marginBottom: '0.5rem',
            fontFamily: "'Inter', sans-serif"
          }}>
            Direct Line
          </div>
          <p style={{
            margin: 0, fontWeight: 700, color: '#0F172A', fontSize: '1.05rem',
            fontFamily: "'Playfair Display', Georgia, serif",
            marginBottom: '0.5rem'
          }}>
            Message Dr. Michael
          </p>
          <p style={{
            margin: '0 0 16px 0', color: '#475569', fontSize: '0.85rem',
            lineHeight: 1.6, fontFamily: "'Inter', sans-serif"
          }}>
            For quick questions, availability, or a confidential conversation.
            Typically replies within minutes.
          </p>

          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              width: '100%',
              background: '#0F172A',
              color: '#FFFCF5',
              textDecoration: 'none',
              padding: '12px 16px',
              borderRadius: '3px',
              fontWeight: 700,
              fontSize: '0.8rem',
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              fontFamily: "'Inter', sans-serif",
              transition: 'background 0.2s ease'
            }}
            onMouseEnter={(e) => { e.currentTarget.style.background = '#C5A059'; e.currentTarget.style.color = '#0F172A'; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = '#0F172A'; e.currentTarget.style.color = '#FFFCF5'; }}
            data-testid="whatsapp-chat-btn"
          >
            Open WhatsApp
          </a>
        </div>
      )}

      <button
        onClick={() => setIsExpanded(!isExpanded)}
        style={{
          width: '58px',
          height: '58px',
          borderRadius: '50%',
          background: '#0F172A',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 8px 24px rgba(15, 23, 42, 0.35)',
          transition: 'transform 0.3s ease, background 0.3s ease',
          position: 'relative'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'scale(1.08)';
          e.currentTarget.style.background = '#C5A059';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.background = '#0F172A';
        }}
        data-testid="whatsapp-btn"
        aria-label="Message Dr. Michael on WhatsApp"
      >
        <svg width="26" height="26" viewBox="0 0 24 24" fill="#C5A059">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
        </svg>
      </button>

      <style>{`
        @keyframes slideInLeft {
          from { opacity: 0; transform: translateX(-20px); }
          to { opacity: 1; transform: translateX(0); }
        }
      `}</style>
    </div>
  );
};

export default WhatsAppButton;
